<script lang="ts">
  export let size: 'tiny' | 'x-small' | 'small' | 'medium' | 'large' | 'full'
  export let fill: string = 'currentColor'
</script>

<svg
  class="svg-{size}"
  viewBox="0 0 24 24"
  fill="none"
  stroke={fill}
  stroke-width="1.5"
  stroke-linecap="round"
  stroke-linejoin="round"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M18 9.00005C18 9.00005 13.5811 15 12 15C10.4188 15 6 9 6 9" />
</svg>
